/**
 * How a caller that only glances at a figure polls for it.
 *
 * A screen built on one endpoint watches it; a dashboard tile reading six of
 * them at once must not, so it passes this. An interval alone is not enough —
 * without `refetchOnWindowFocus` every return to the tab re-fires all of them.
 */
export type GlanceOptions = {
  refetchInterval?: number | false
  refetchOnWindowFocus?: boolean
  staleTime?: number
}

/**
 * How often a dashboard reads: once a minute, and not again on every return
 * to the tab. One value, so the tiles and the panels above them cannot end up
 * on different cadences.
 *
 * A hook whose own default is load-bearing — a cadence computed from the data,
 * a result too expensive to refetch — takes that key out of the spread and
 * keeps its own.
 */
export const GLANCE: GlanceOptions = {
  refetchInterval: 60_000,
  refetchOnWindowFocus: false,
  staleTime: 30_000,
}
